
export class EventDeliveryState {
    loading = false;
    error = null;
    record: any = null;
}
